import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import uuid from "uuidv4";
import { useLazyQuery } from "@apollo/client";

import { GET_VEHICLE_BY_SOURCE_ID } from "../../../../../../../GraphQL/Queries/vehicles";
// import { UPDATE_VEHICLE, CREATE_VEHICLE } from "../../../../../../../GraphQL/Mutations/vehicles";
// import { parseVehicleForm } from "./utils/helpers";

import { uploadS3 } from "../../../../../../../Helpers/uploadFile";

const formInitialState = { star: 3, available_date: '', warranty_date: '', retire_date: '', engine: 0, drive_train: 0, body_style: 0, transmission: 0, tires: 0, roof: 0, km: 0, fuel: 8, plate: '', is_new_model: false, is_prototype: false, is_redesign: false };

export const useVehicleForm = (settings, match, history, editingVehicle, vehicle_oem_details, vehicle_options, redirectAfterCreation) => {
	const [vehicleForm, setVehicleForm] = useState(formInitialState);
	const [formDetails, setFormDetails] = useState({});
	const [loadingImage, setLoadingImage] = useState(false);
	const [loadingSpec, setLoadingSpec] = useState(false);
    const [imageThumbnail, setImageThumbnail] = useState(null);
    const [imageName, setImageName] = useState(null);
	const [specName, setSpecName] = useState(false);
    const [specThumbnail, setSpecThumbnail] = useState(null);
	const [specType, setSpecType] = useState('FILE');

	const [vehicleOptions, setVehicleOptions] = useState(settings.vehicle_options);
	const [vehicleOemDetails, setVehicleOemDetails] = useState(settings.vehicle_details);

    const [loadingSubmit, setLoadingSubmit] = useState(false);

    // const [createVehicleMutation, { data: createdVehicle, loading: createLoading, error: createError }] = useMutation(CREATE_VEHICLE);
    // const [updateVehicleMutation, { data: updatedVehicle, loading: updateLoading, error: updateError }] = useMutation(UPDATE_VEHICLE);
    const [getVehicleQuery, { loading: loadingVehicle }] = useLazyQuery(GET_VEHICLE_BY_SOURCE_ID);

    const { params: { v_id, id: vehicleId } } = match;

	useEffect(() => {
		getVehicleFormValues();
	}, []);

    useEffect(() => {
        setVehicleOptions(vehicle_options || settings.vehicle_options);
        setVehicleOemDetails(vehicle_oem_details || settings.vehicle_details);
    }, [vehicle_options, vehicle_oem_details]);

	useEffect(() => {
		if (editingVehicle) {
			parseVehicleDataToForm(editingVehicle);
		}
	}, [editingVehicle]);

	const updateVehicleForm = (event) => {
        const { type, checked, value, name } = event.target;
        const formValue = type === 'checkbox' ? checked : value;

		setVehicleForm(previousState => ({ ...previousState, [name]: formValue }));
    }

	const setStarValue = (value) => {
		setVehicleForm(previousState => ({ ...previousState, star: value }));
    }

    // This code was removed from the component file, it was not refactored because we are not using it anymore when we finish the migration
    const parseVehicleDataToForm = (vehicle) => {
        const vehicle_keys = Object.keys(vehicle)
        const vehicle_form = {}

        for (var i = 0; i < vehicle_keys.length; i++) {
            if (vehicle_keys[i] === 'Unique_Tag') {
                vehicle_form["tag"] = vehicle[vehicle_keys[i]]
            } else if (vehicle_keys[i] === 'License_Plate') {
                vehicle_form["plate"] = vehicle[vehicle_keys[i]]
            } else if (vehicle_keys[i] === 'Num_Keys') {
                vehicle_form["keys"] = vehicle[vehicle_keys[i]]
            } else if (vehicle_keys[i] === 'Odometer') {
                vehicle_form["km"] = vehicle[vehicle_keys[i]]
            } else if (vehicle_keys[i] === 'Fuel_Level') {
                vehicle_form["fuel"] = vehicle[vehicle_keys[i]]
            } else if (vehicle_keys[i] === 'Catalogue_Link') {
                vehicle_form["spec_sheet"] = vehicle[vehicle_keys[i]]
                if (vehicle["Catalogue_Link"]) {
                    if (vehicle["Catalogue_Link"].includes("https://digitalvms.s3.ca-central-1.amazonaws.com/specsheets/")) {
                        let spec_name = vehicle["Catalogue_Link"]
                        spec_name = spec_name?.split("/")
                        spec_name = spec_name[spec_name.length - 1]
                        spec_name = spec_name?.split(".")

                        let extension = spec_name[spec_name.length - 1]
                        spec_name = spec_name[0]
                        spec_name = spec_name?.split("_").slice(0, -1).join('_');

						setSpecName(`${spec_name}.${extension}`);
                    } else if (vehicle["Catalogue_Link"].includes("uploads/specs/")) {
						setSpecName(vehicle["Catalogue_Link"]);
                    } else {
						setSpecType("LINK");
                    }
                }
            } else if (vehicle_keys[i] === 'Available_Date') {
                if (moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').isValid)
                    vehicle_form["available_date"] = moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').format('MM-DD-YYYY');
                else
                    vehicle_form["available_date"] = '';
            } else if (vehicle_keys[i] === 'Warranty_Date') {
                if (moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').isValid)
                    vehicle_form["warranty_date"] = moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').format('MM-DD-YYYY');
                else
                    vehicle_form["warranty_date"] = '';
            } else if (vehicle_keys[i] === 'Retire_Date') {
                if (moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').isValid)
                    vehicle_form["retire_date"] = moment(vehicle[vehicle_keys[i]], 'YYYY-MM-DD').format('MM-DD-YYYY');
                else
                    vehicle_form["retire_date"] = '';
            } else {
                vehicle_form[vehicle_keys[i].toLowerCase()] = vehicle[vehicle_keys[i]]
            }
        }

        if (vehicle.tier && vehicle.tier.length > 0) {
            vehicle_form['star'] = vehicle.tier[0].Rank
        } else if (vehicle.tier) {
            vehicle_form['star'] = vehicle.tier
        }

		setVehicleForm(previousState => ({ ...previousState, ...vehicle_form }));
    }

	const getVehicleFormValues = () => {
        axios.get('/ajax/vehicle/create')
            .then(function(response) {
                const { available_date, km, fuel, ...createForm } = response?.data.view;

                // this is setting the default values for the form like the oem_id, sh_id, vmh_id, etc...
				if (!editingVehicle) {
					setFormDetails(previousState => ({ ...createForm, ...previousState }));
					setVehicleForm(previousState => ({ ...createForm, ...previousState }));
                }
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

	const submitEdit = async () => {
        setLoadingSubmit(true);

        const updateBody = {
            ...vehicleForm,
            available_date: vehicleForm.available_date && moment(vehicleForm.available_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.available_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
            warranty_date: vehicleForm.warranty_date && moment(vehicleForm.warranty_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.warranty_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
            retire_date: vehicleForm.retire_date && moment(vehicleForm.retire_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.retire_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
        }

        // Removed to use the new vehicle sync from the Legacy API
        // const parsedForm = parseVehicleForm(vehicleId, updateBody, vehicleOemDetails, specType);
        // await updateVehicleMutation({ variables: { input: parsedForm } });

        legacyApiEditVehicle(updateBody);
    }

    const legacyApiEditVehicle = (updateBody) => {
        axios.post('/ajax/vehicle/' + v_id + "/update", updateBody)
            .then((response) => {
                // showStatusMsg(response?.data.message, 'success')
                showStatusMsg('Vehicle has been updated successfully.', 'success');
                setLoadingSubmit(false);

                // TODO: get the vehicle again instead of reloading the page
                window.location.assign(`/vehicleoverview/vehicle/${v_id}/Overview/${vehicleId}`); // this should be a temporary fix
            })
            .catch(function(error) {
                setLoadingSubmit(false);

                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    const submitNew = (isOrderToVehicleConversion = false, convertInventoryToVehicle = null) => {
        setLoadingSubmit(true);

        const requiredFieldsFilled = checkRequiredFields();
        if (!requiredFieldsFilled) return;

        const createBody = {
            ...vehicleForm,
            available_date: vehicleForm.available_date && moment(vehicleForm.available_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.available_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
            warranty_date: vehicleForm.warranty_date && moment(vehicleForm.warranty_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.warranty_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
            retire_date: vehicleForm.retire_date && moment(vehicleForm.retire_date, 'MM-DD-YYYY').isValid() ? moment(vehicleForm.retire_date, 'MM-DD-YYYY').format('YYYY-MM-DD') : '',
        }

        if (isOrderToVehicleConversion && convertInventoryToVehicle) {
            legacyApiConvertInventoryIntoVehicle(createBody, convertInventoryToVehicle);
            return;
        }

        legacyApiCreateVehicle(createBody);
    }

    // Removed to use the new vehicle sync from the Legacy API
    // const createVehicle = async (createBody, sourceVehicleId) => {
    //     const parsedForm = parseVehicleForm(vehicleId, createBody, vehicleOemDetails, specType);

    //     const createVehicleMutationInput = {
    //         ...parsedForm,
    //         sourceVehicleId,
    //         active: true,
    //         isDamaged: false,
    //     }

    //     const response = await createVehicleMutation({ variables: { input: createVehicleMutationInput } });
    //     return response?.data?.createVehicle;
    // }

    const legacyApiCreateVehicle = (createBody) => {
        axios.post('/ajax/vehicle', createBody)
            .then((response) => {
                const { id: sourceVehicleId, vehicle } = response?.data;
                setLoadingSubmit(false);

                if (redirectAfterCreation) {
                    showStatusMsg('Vehicle has been created successfully.', 'success');
                    window.location.assign(`/vehicleoverview/vehicle/${vehicle.V_ID}/Overview/${sourceVehicleId}`);
                }
            })
            .catch((error) => {
                console.log('error :>> ', error);
                setLoadingSubmit(false);

                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Vehicle could not be created.");
                }
            })
            .finally(() => {
                setLoadingSubmit(false);
            });
    }

    const legacyApiConvertInventoryIntoVehicle = (createBody, convertInventoryToVehicle) => {
        axios.post('/ajax/vehicle/inventory', createBody)
            .then(async (response) => {
                const legacyApiCreatedVehicleId = response?.data?.vehicle?.V_ID;
                const createdVehicleId = response?.data?.id;

                await convertInventoryToVehicle(createdVehicleId, legacyApiCreatedVehicleId);

                setLoadingSubmit(false);
                showStatusMsg('Order has been converted to Inventory successfully.', 'success');
                window.location.assign(`/vehicleoverview/vehicle/${legacyApiCreatedVehicleId}/Overview/${createdVehicleId}`);
            })
            .catch((error) => {
                console.log('error :>> ', error);
                setLoadingSubmit(false);

                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Vehicle could not be created.");
                }
            })
            .finally(() => {
                setLoadingSubmit(false);
            });
    }

	//

	const updateSelect = (optionSelected) => {
		const { name, value } = optionSelected;

        if (name === 'oem_id') {
            loadDivisions(value);
        }

		if (name === 'sh_id') {
            loadVMHs(value);
        }

		setVehicleForm(previousState => ({ ...previousState, [name]: value }));
    }

    const loadDivisions = (value) => {
        axios.post('/ajax/stakeholder/' + value + '/options', { filter: 'stakeholder_with_booking' })
			.then((response) => {
				const divisions = response?.data.stakeholders;

				setFormDetails(previousState => ({ ...previousState, divisions }));

				setVehicleOptions(response?.data.constants.vehicle_options);
				setVehicleOemDetails(response?.data.constants.vehicle_details);

				if (divisions.length > 0) {
					const { value } = divisions[0];

					setVehicleForm(previousState => ({ ...previousState, sh_id: value }));
					loadVMHs(value);
				}
			})
    }

    const loadVMHs = (value) => {
        axios.post('/ajax/vmh/' + value + '/options', { filter: 'stakeholder_with_booking' })
			.then((response) => {
				const { vmhs } = response?.data;

				setFormDetails(previousState => ({ ...previousState, vmhs }));

				if (vmhs.length > 0) {
					const { value } = vmhs[0];

					setVehicleForm(previousState => ({ ...previousState, vmh_id: value }));
				}
			})
    }

	//

    const legacyApiUploadImage = (file) => {
        const filename = file.name.replace(/[/\\?%*:|"<>]/g, '-');
        const extension = filename?.split('.').pop();

        const originalFilename = filename.slice(0, -(extension.length + 1));

        uploadS3(file, originalFilename, extension, "/vehicle-images", uuid(), function(response) {
            const photos = response;
            const photos_name = `${originalFilename}.${extension}`;

            setVehicleForm(previousState => ({ ...previousState, photos, photos_name }));
        }, function(error) {
            console.error('legacy API upload image error: ', error);
        })
    }

    const legacyApiUploadSpecSheet = (file) => {
        const filename = file.name?.split(/(\\|\/)/g).pop()
        const originalFilename = filename?.split(".")[0]
        const extension = filename?.split(".")[1].toLowerCase();

        uploadS3(file, originalFilename, extension, "/specsheets", null, function(response) {
            const spec_sheet = `https://digitalvms.s3.ca-central-1.amazonaws.com/specsheets/${response}`;

            setVehicleForm(previousState => ({ ...previousState, spec_sheet }));
        }, function(error) {
            console.error('legacy API upload specsheet error: ', error);
        })
    }

	const uploadImage = (files) => {
		const [file] = files;

        if (!file) return;

		setLoadingImage(true);

        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showStatusMsg('Incorrect filetype for Vehicle Image. Please upload a .jpg, .jpeg, or .png file', 'error');
            setLoadingImage(false);
            return;
        }

        if (file.size / 1000 > 8000) {
            showStatusMsg('Maximum file size is 8 MB. Please compress your image and try again.', 'error');
            setLoadingImage(false);
            return;
        }

        legacyApiUploadImage(file);

        const currentUrl = window.location.hostname.replace('www.', '');
        const uploadUrl = `https://api.${currentUrl}/vehicle_image_uploads`

        const formData = new FormData();
        formData.append("file", file);

        axios.post(uploadUrl, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(({ data }) => {
            setVehicleForm(previousState => ({ ...previousState, photoId: data.fileId }));

            setImageName(file.name);
            setImageThumbnail(data.signedUrl);

            setLoadingImage(false);
        }).catch((error) => {
            console.error('uploading image error: ', error);
            showStatusMsg('There was an error uploading your image. Please try again.', 'error');

            setLoadingImage(false);
        });
    }

	const uploadSpecSheet = (files) => {
        const [file] = files;

        if (!file) return;

		setLoadingSpec(true);

        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(file.type)) {
            showStatusMsg('Incorrect filetype for Spec Sheet. Please upload a .doc, .docx, or .pdf file', 'error');
            setLoadingSpec(false);
            return;
        }

        legacyApiUploadSpecSheet(file);

        const currentUrl = window.location.hostname.replace('www.', '');
        const uploadUrl = `https://api.${currentUrl}/vehicle_spec_uploads`

        const formData = new FormData();
        formData.append("file", file);

        axios.post(uploadUrl, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(({ data }) => {
            setVehicleForm(previousState => ({ ...previousState, specSheetId: data.fileId }));

            setSpecName(file.name);
            setSpecThumbnail(data.signedUrl);

            setLoadingSpec(false);
        }).catch((error) => {
            console.error('uploading spec sheet error: ', error);
            showStatusMsg('There was an error uploading your spec sheet. Please try again.', 'error');

            setLoadingSpec(false);
        });
    }

	const selectSpecType = (type) => {
        if (!type) return;

		//clear value and set to file type
		setVehicleForm(previousState => ({ ...previousState, spec_sheet: '' }));

		setSpecType(type);
	}

    const setSpecSheet = (specUrl) => {
        if (!specUrl) return;

        setVehicleForm(previousState => ({ ...previousState, spec_sheet: specUrl }));

        if (specUrl.includes('/vehicleSpecs') || specUrl.includes('/specsheets')) {
            setSpecType('FILE');
            setSpecThumbnail(specUrl);
        } else {
            setSpecType('LINK');
        }
    }

    const checkRequiredFields = () => {
        const { year, make, model, vin, oem_id, sh_id, vmh_id, available_date } = vehicleForm;

        if (!year || !make || !model || !vin || !oem_id || !sh_id || !vmh_id || !available_date) {
            showStatusMsg('Please fill out all required fields', 'error');
            setLoadingSubmit(false);

            return false;
        }

        return true;
    }

	return {
        vehicleId,
		vehicleForm,
		updateVehicleForm,
		setStarValue,
		formDetails,
		setVehicleForm,
		uploadImage,
		loadingImage,
		uploadSpecSheet,
		loadingSpec,
		specName,
        specThumbnail,
		specType,
        setSpecSheet,
		selectSpecType,
		vehicleOptions,
		vehicleOemDetails,
		updateSelect,
		submitNew,
		submitEdit,
        loadingSubmit,
        imageThumbnail,
        imageName,
        loadDivisions,
        loadVMHs,
	}
};
